import { Component, Input } from '@angular/core';
import { Equipo } from '@domain/equipo';
import { EstatusRetosEquipo } from '@domain/estatus.reto.equipo';
import { Jugador } from '@domain/jugador';

@Component({
  selector: 'espera-ronda',
  templateUrl: 'espera-ronda.html'
})
export class EsperaRondaComponent {

  @Input('equipo') equipo: Equipo;
  @Input('jugador') jugador: Jugador;
  @Input('estatus') estatus: EstatusRetosEquipo;

  constructor() {  }

}



// WEBPACK FOOTER //
// ./src/components/espera-ronda/espera-ronda.ts